import React from 'react';
import './insightcards.css';

const InsightsCard = ({ icon, text, color }) => {
  return (
    <div
      style={{
        backgroundColor: `${color}15`,
        padding: '1rem 1rem',
        borderLeft: `4px solid ${color}`,
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'left',
        gap: '0.5rem',
        marginBottom: '1rem',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.03)',
        transition: 'transform 0.2s ease',
        cursor: 'default',
      }}
      className="insight-card"
    >
      <div
        style={{
        //   backgroundColor: `${color}15`,
          padding: '0.5rem',
          borderRadius: '50%',
          color: color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.25rem',
          minWidth: '2.5rem',
          height: '2.5rem',
        }}
      >
        {icon}
      </div>
      <div style={{ fontSize: '0.95rem', fontWeight: 500 }}>{text}</div>
    </div>
  );
};

export default InsightsCard;
